/**
 * Centralized copy for the Account Managers page. Kept out of the component
 * per the repo rule that feature text is not hardcoded inline (mirrors
 * MemberSecurityTab.strings.ts).
 */
export const accountManagersStrings = {
  title: 'Account Managers',
  sync: {
    button: 'Sync from HubSpot',
    syncing: 'Syncing...',
    error: 'Failed to sync account managers from HubSpot',
    success: 'Sync completed successfully!',
    failed: 'Sync failed',
    totalSynced: 'Total synced: {count}',
    created: 'Created: {count}',
    updated: 'Updated: {count}',
    deactivated: 'Deactivated: {count}',
    disabled:
      'The sync was not run: HubSpot has been switched off, so account managers can no longer be synced from it. Nothing was changed.',
    emptyRefused:
      'HubSpot returned no account managers, so the sync was refused and nothing was changed. The roster below is unchanged.',
  },
  frozen:
    'HubSpot has been switched off, so the roster no longer syncs from it. Add and deactivate account managers here.',
  errorLabel: 'Error:',
  fetchError: 'Failed to fetch account managers',
  showing: 'Showing {shown} of {total} account managers',
  showInactive: 'Show inactive',
  table: {
    name: 'Name',
    email: 'Email',
    members: 'Members',
    actions: 'Actions',
    inactiveName: '{name} (inactive)',
    empty: 'No account managers found.',
    emptyWithSync:
      'No account managers found. Click "Sync from HubSpot" to fetch account managers.',
  },
  actions: {
    deactivate: 'Deactivate',
    activate: 'Activate',
  },
  add: {
    link: '+ Add manager',
    fullName: 'Full name',
    email: 'Email',
    submit: 'Add',
    cancel: 'Cancel',
    nameInvalid: 'Enter a first and a last name',
    emailInvalid: 'Enter a valid e-mail',
    duplicateEmail: 'A manager with this e-mail already exists',
  },
  refusal: {
    unverified:
      'Your sign-in could not be verified. Sign in again and retry.',
    forbidden: 'You do not have permission to manage account managers.',
    unavailable:
      'The permission check is unavailable right now. Try again later.',
    notFound: 'This account manager no longer exists. The list was refreshed.',
    generic: 'The change could not be saved. Try again.',
    signInAgain: 'Sign in again',
  },
} as const;

/**
 * Replaces `{token}` placeholders with provided values; unknown tokens are left
 * intact so missing interpolation is visible.
 */
export const formatMessage = (
  template: string,
  vars: Record<string, string | number> = {},
): string =>
  template.replace(/\{(\w+)\}/g, (match, key: string) =>
    Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : match,
  );
